"use client";

import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const templates = [{
  id: 1,
  image: "https://werkys.com/wp-content/uploads/2026/05/athlon-scaled.webp"
}, {
  id: 2,
  image: "https://werkys.com/wp-content/uploads/2026/05/bright-scaled.webp"
}, {
  id: 3,
  image: "https://werkys.com/wp-content/uploads/2026/05/cryptovelt-scaled.webp"
}, {
  id: 4,
  image: "https://werkys.com/wp-content/uploads/2026/05/placer-scaled.webp"
}, {
  id: 5,
  image: "https://werkys.com/wp-content/uploads/2026/05/samosas-scaled.webp"
}, {
  id: 6,
  image: "https://werkys.com/wp-content/uploads/2026/05/Scrip-scaled.webp"
}];

// duplicate for seamless infinite scrolling
const duplicatedTemplates = [...templates, ...templates];
export default function TemplateShowcase() {
  return <section id="portfoliocarousel" className="w-full overflow-hidden bg-background py-20">
      <div className="mb-14 text-center">
        <h2 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold tracking-[0.12em] text-foreground leading-[1.1] mb-6">
          CONVERSION-FOCUSED DESIGNS
        </h2>

        <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
          Explore our collection of high-performance layouts built for speed and
          conversion
        </p>
      </div>

      <div className="relative">
        <div className="flex animate-marquee gap-6 w-max">
          {duplicatedTemplates.map((template, index) => <div key={`${template.id}-${index}`} className="w-[320px] sm:w-[420px] lg:w-[520px] shrink-0">
              <Card className="overflow-hidden border-0 bg-transparent shadow-none">
                <CardContent className="p-0">
                  <div className="group relative overflow-hidden rounded-3xl">
                    <AspectRatio ratio={16 / 9}>
                      <img src={template.image} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </AspectRatio>

                    <div className="absolute inset-0 bg-black/10 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {/* left fade */}
        <div className="pointer-events-none absolute left-0 top-0 h-full w-32 bg-gradient-to-r from-background to-transparent z-10" />

        {/* right fade */}
        <div className="pointer-events-none absolute right-0 top-0 h-full w-32 bg-gradient-to-l from-background to-transparent z-10" />
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0%);
          }

          100% {
            transform: translateX(-50%);
          }
        }

        .animate-marquee {
          animation: marquee 35s linear infinite;
        }

        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}